import cn from 'classnames';
import styles from './Timeline.module.css';

type TimelineProps = {
    title?: string;
    steps: string[];
    activeStep?: number;
};

export const Timeline = ({ title, steps, activeStep = 0 }: TimelineProps) => (
    <div className="s-bg-info-subtle flex flex-col gap-16 p-16 rounded-8 w-full">
        {title && <strong className="text-16 font-bold m-0 s-text">{title}</strong>}
        {steps.map((step, index) => (
            <div key={step} className={cn(styles.step, 'relative flex items-center row nowrap')}>
                <span
                    className={`rounded-full border-2 s-border-primary s-bg w-16 h-16 mr-8 flex-shrink-0 relative z-10 ${index === activeStep && 's-bg-primary'}`}
                />
                <p className="text-14 m-0">{step}</p>
            </div>
        ))}
    </div>
);
